/* eslint-disable react/function-component-definition */
import './TableInspectionTemplate.style.less'
import { Space, Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import PopUpMenu from '../../../../Components/PopUpMenu/PopUpMenu'
import { useNavigate } from 'react-router-dom'

interface Props {
  data: any
  isLoading: boolean
  onDelete: (id: string) => void
}
interface DataType {
  id: any
  name: string
  type: string
}

const TableInspectionTemplate = (props: Props) => {
  const navigate = useNavigate()
  const columns: ColumnsType<DataType> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      // sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: '19%',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <PopUpMenu
            onEdit={() =>
              navigate(
                `/system-configure/template/edit-inspection-template/${record.id}`
              )
            }
            onDelete={() => props.onDelete(record.id)}
          />
        </Space>
      ),
      width: '5%',
    },
  ]

  return (
    <Table
      loading={props.isLoading}
      columns={columns}
      dataSource={props.data}
    />
  )
}

export default TableInspectionTemplate
